var render = function render(){var _vm=this,_c=_vm._self._c;return _c('treeselect',{attrs:{"options":_vm.options,"value":_vm.value,"normalizer":_vm.normalizer}})
}
var staticRenderFns = []

export { render, staticRenderFns }